import { Smartphone } from "lucide-react";
import { useEffect } from "react";
import { BrandMark } from "../components/BrandMark";

// Handoff-Weblink für die versteckte Directus-Anmeldung in der Expo-App:
// https://<tenant-domain>/app leitet auf vzlive://sso-directus weiter.
export function AppHandoffPage() {
  useEffect(() => {
    window.location.replace("vzlive://sso-directus");
  }, []);

  return (
    <div className="auth-simple">
      <BrandMark inverse />
      <main id="main" className="auth-card auth-card--invite">
        <span className="auth-card__icon">
          <Smartphone />
        </span>
        <h1>App wird geöffnet.</h1>
        <p>
          Der Live-Desk startet in der VZ.live-App. Falls nichts passiert, ist
          die App nicht installiert – tippe dann auf den Button.
        </p>
        <button onClick={() => window.location.assign("vzlive://sso-directus")}>
          App öffnen <Smartphone size={17} />
        </button>
      </main>
    </div>
  );
}
